import { Component } from '@angular/core';

@Component({
    selector: 'market-product',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class MarketProductComponent {}
